import { formEvents } from "@cd2/forms/build/es6/Form2"
import { FormState } from "@cd2/forms/build/es6/Form2/FormState"

export function formStateSetErrors(formState: FormState, errors: Record<string, any>) {
  formState.state.errors = { ...errors }

  const currentFields = Object.keys(formState.state.fields)
  const settingFields = Object.keys(errors)
  const fieldsToUpdate = currentFields.filter(field => settingFields.includes(field))

  fieldsToUpdate.forEach(field => formState.getField(field).triggerChange())
  formState.events.trigger(formEvents.dataChange)
}
